import React, { useEffect } from "react";

import { getVSIFileIcon } from "file-extension-icon-js";

import { Badge, Rate, Menu, Dropdown, List, Avatar } from "antd";

import {
  validarVisualizar,
  validarSePassouDaDataDeValidade,
  validarData,
  getIconesExtensao,
} from "../../services/utils";

import TableHeader from "../Table/Header";
import TablePagination from "../Table/Pagination";
import RowDragInDrop from "../Table/RowDragInDrop";

import IconeArquivos from "../IconeArquivos";

import favoritoSvg from "../../assets/icons/iconFavoritado.svg";
import pastaSvg from "../../assets/icons/infoPasta.svg";
import infoArquivoSvg from "../../assets/icons/infoArquivo.svg";
import menuAbrir from "../../assets/iconsMenu/menuAbrir.svg";
import menuInfo from "../../assets/iconsMenu/menuInfo.svg";
import menuCompartilhar from "../../assets/iconsMenu/menuCompartilhar.svg";
import menuCopiar from "../../assets/iconsMenu/menuCopiar.svg";
import menuEditar from "../../assets/iconsMenu/menuEditar.svg";
import menuFavorito from "../../assets/iconsMenu/menuFavorito.svg";
import menuMover from "../../assets/iconsMenu/menuMover.svg";
import menuRemover from "../../assets/iconsMenu/menuRemover.svg";
import menuRenomear from "../../assets/iconsMenu/menuRenomear.svg";
import menuRemoverLink from "../../assets/icons/iconRemoverLink.svg";
import iconLinkSvg from "../../assets/icons/iconLink.svg";
import iconDownloadSvg from "../../assets/icons/iconDownload.svg";
import iconSairCompartilhamentoSvg from "../../assets/icons/iconSairCompartilhamento.svg";
import IcTresPontos from "../../assets/icons/iconeTresPontinhos.svg";
import "./styles.scss";
import moment from "moment";

let tabelaColunas = [];

const ListagemPastasCompartilhadas = ({
  data,
  mudarPagina,
  buscarPastasFilhas,
  showInfo,
  favoritar,
  showEditar,
  showRenomear,
  removerItem,
  IsAdmin,
  downloadFile,
  gerarLinkunico,
  handleRemoverFavorito,
  mostrarListagemLinks,
  handleRemoverLink,
  showModalVisualizar,
  atualizarPastasDragInDrop,
  showModalCompartilhar,
  handleSairCompartilhamento,
  algumCompartilhamento,
  showModalCopiar,
  showModalMover,
  ordenacao,
  setOrdenacao,
}) => {


  if (data.lista?.find((item) => item.donoCompartilhamento != null)) {
    tabelaColunas = [
      <img src={favoritoSvg} />,
      "Nome",
      "Dono",
      "Tamanho",
      "Tipo",
      "Acesso", 
      "Data Compartilhamento",
    ];
  } else {
    tabelaColunas = [
      <img src={favoritoSvg} />,
      "Nome",
      "Compartilhado com",
      "Tamanho",
      "Tipo",
      "Acesso", 
      "Data Compartilhamento",
    ];
  }
 

  const formatarData = (value) => {
    if (value) {
      const data = new Date(value);
      return data.toLocaleDateString("pt-BR", { timeZone: "UTC" });
    }
  };

  const visualizacao = (item) => {
    let extensao = String(item.nome).split(".")[1];

    let extensaoValida = validarVisualizar(extensao);

    if (
      extensaoValida != "nao-suportado" &&
      !validarSePassouDaDataDeValidade(item.dataVencimento)
    ) {
      return (
        <>
          <Menu.Item
            key="1"
            onClick={() => showModalVisualizar(item)}
            icon={<img src={menuAbrir} />}
          >
            Visualizar
          </Menu.Item>
          <hr className="linha-menu" />
        </>
      );
    }
  };

  const showMenu = (id, tipo, item) => {
    if (item.donoCompartilhamento) {
      return (
        <div className="menu">
          <Menu>
            {tipo == "pasta" &&
            !validarSePassouDaDataDeValidade(item.dataVencimento) ? (
              <>
                <Menu.Item
                  key="1"
                  onClick={() => {
                    buscarPastasFilhas(id, tipo, item.nome);
                  }}
                  icon={<img src={menuAbrir} />}
                >
                  Abrir
                </Menu.Item>
                <hr className="linha-menu" />
              </>
            ) : (
              <>{visualizacao(item)}</>
            )}
            <Menu.Item
              key="2"
              onClick={() => showInfo(id, tipo)}
              icon={<img src={menuInfo} />}
            >
              Info
            </Menu.Item>
            {item.ehFavorito ? (
              <Menu.Item
                key="3"
                onClick={() => handleRemoverFavorito(item)}
                icon={<img src={menuFavorito} />}
              >
                Remover favorito
              </Menu.Item>
            ) : (
              <Menu.Item
                key="3"
                onClick={() => favoritar(item)}
                icon={<img src={menuFavorito} />}
              >
                Favorito
              </Menu.Item>
            )}
            <hr className="linha-menu" />
            {!validarSePassouDaDataDeValidade(item.dataVencimento) ? (
              <Menu.Item
                key="4"
                onClick={() => downloadFile(item)}
                icon={<img src={iconDownloadSvg} />}
              >
                Fazer download...
              </Menu.Item>
            ) : null}
            {IsAdmin.toLocaleLowerCase() == "true" && (
              <>
                <hr className="linha-menu" />
                <Menu.Item
                  key="5"
                  onClick={() => showEditar(id, tipo)}
                  icon={<img src={menuEditar} />}
                >
                  Editar
                </Menu.Item>
                {item.tipo == 0 ||
                  (item.tipo == 1 && (
                    <>
                      <Menu.Item
                        key="11"
                        icon={<img src={menuCopiar} />}
                        onClick={() => showModalCopiar(item)}
                      >
                        Copiar
                      </Menu.Item>
                    </>
                  ))}
                <hr className="linha-menu" />
                <Menu.Item
                  key="6"
                  onClick={() => handleSairCompartilhamento(item)}
                  icon={<img src={iconSairCompartilhamentoSvg} />}
                >
                  Sair do compartilhamento
                </Menu.Item>
              </>
            )}
          </Menu>
        </div>
      );
    } else {
      return (
        <div className="menu">
          <Menu>
            {tipo == "pasta" &&
            !validarSePassouDaDataDeValidade(item.dataVencimento) ? (
              <>
                <Menu.Item
                  key="1"
                  onClick={() => buscarPastasFilhas(id, tipo, item.nome)}
                  icon={<img src={menuAbrir} />}
                >
                  Abrir
                </Menu.Item>
                <hr className="linha-menu" />
              </>
            ) : (
              <>{visualizacao(item)}</>
            )}
            <Menu.Item
              key="2"
              onClick={() => showInfo(id, tipo)}
              icon={<img src={menuInfo} />}
            >
              Info
            </Menu.Item>
            {item.ehFavorito ? (
              <Menu.Item
                key="3"
                onClick={() => handleRemoverFavorito(item)}
                icon={<img src={menuFavorito} />}
              >
                Remover favorito
              </Menu.Item>
            ) : (
              <Menu.Item
                key="3"
                onClick={() => favoritar(item)}
                icon={<img src={menuFavorito} />}
              >
                Favorito
              </Menu.Item>
            )}
            <hr className="linha-menu" />
            {!validarSePassouDaDataDeValidade(item.dataVencimento) ? (
              <Menu.Item
                key="4"
                onClick={() => downloadFile(item)}
                icon={<img src={iconDownloadSvg} />}
              >
                Fazer download...
              </Menu.Item>
            ) : null}
            {mostrarListagemLinks && (
              <Menu.Item
                key="5"
                onClick={() => {
                  gerarLinkunico(item);
                }}
                icon={<img src={iconLinkSvg} />}
              >
                Gerenciar link
              </Menu.Item>
            )}
            {mostrarListagemLinks == false &&
              !validarData(item.dataVencimento) && (
                <Menu.Item
                  key="5"
                  onClick={() => {
                    gerarLinkunico(item);
                  }}
                  icon={<img src={iconLinkSvg} />}
                >
                  Obter link
                </Menu.Item>
              )}
            {mostrarListagemLinks && (
              <Menu.Item
                key="6"
                onClick={() => {
                  handleRemoverLink(item.id);
                }}
                icon={<img src={menuRemoverLink} />}
              >
                Remover link
              </Menu.Item>
            )}
            {item.tipo == 0 && (
              <Menu.Item
                key="7"
                onClick={() => {
                  showModalCompartilhar(item);
                }}
                icon={<img src={menuCompartilhar} />}
              >
                Compartilhar
              </Menu.Item>
            )}
            {IsAdmin.toLocaleLowerCase() == "true" && (
              <>
                <hr className="linha-menu" />
                <Menu.Item
                  key="8"
                  onClick={() => showEditar(id, tipo)}
                  icon={<img src={menuEditar} />}
                >
                  Editar
                </Menu.Item>
                {!item.donoCompartilhamento && (
                  <Menu.Item
                    key="9"
                    onClick={() => showRenomear(id, tipo)}
                    icon={<img src={menuRenomear} />}
                  >
                    Renomear
                  </Menu.Item>
                )}
                {item.tipo == 0 && (
                  <>
                    <Menu.Item
                      key="10"
                      icon={<img src={menuMover} />}
                      onClick={() => showModalMover(item)}
                    >
                      Mover
                    </Menu.Item>
                    <Menu.Item
                      key="11"
                      icon={<img src={menuCopiar} />}
                      onClick={() => showModalCopiar(item)}
                    >
                      Copiar
                    </Menu.Item>
                  </>
                )}
                <hr className="linha-menu" />
                <Menu.Item
                  key="12"
                  onClick={() => removerItem(id, tipo)}
                  icon={<img src={menuRemover} />}
                >
                  Remover
                </Menu.Item>
              </>
            )}
          </Menu>
        </div>
      );
    }
  };

  const showIniciais = (nome) => {
    let nomecompleto = nome.replace(".", " "); 
    var iniciais = nomecompleto.match(/\b(\w)/gi);
    var sobrenomes = iniciais.splice(0, iniciais.length).join("").toUpperCase(); 
    return sobrenomes;
  };

  const showMenuUsuariosCompartilhados = (item) => {
    return (
      <div className="menu">
        <Menu>
          {item.map((usuario, index) => {
            if (index > 0) {
              return (
                <Menu.Item>
                  <Badge size="small">
                    <Avatar style={{ background: "#0042DD", color: "#FFFFFF" }}>
                      {showIniciais(usuario)}
                    </Avatar>
                  </Badge>
                  <span style={{ marginLeft: "1rem" }}>{usuario}</span>
                </Menu.Item>
              );
            }
          })}
        </Menu>
      </div>
    );
  };

  const colunaCompartilhadoComDono = (item) => {
    if (item.usuariosCompartilhados) {
      if (item.usuariosCompartilhados?.length > 1) {
        return (
          <div className="lista-pasta-compartilhada-usuarios">
          <Badge size="small">
            <Avatar style={{ background: "#0042DD", color: "#FFFFFF" }}>
              {showIniciais(item.usuariosCompartilhados[0])}
            </Avatar>
          </Badge>
          <span className="nomeUsuario-compartilhado">
            {item.usuariosCompartilhados[0]}
          </span>
          <div className="moverIcone">

          <List.Item className="list-item ">
            <Dropdown.Button
              trigger={["click"]}
              className="button-list"
              overlay={() =>
                showMenuUsuariosCompartilhados(item.usuariosCompartilhados)
              }
              placement="bottomLeft"
              icon={<img src={IcTresPontos} alt="Ícone" />}
              ></Dropdown.Button>
          </List.Item>
              </div>
        </div>
        
        
        );
      } else {
        return (
          <span className="lista-pasta-compartilhada-usuairos">
            <Badge size="small">
              <Avatar style={{ background: "#0042DD", color: "#FFFFFF" }}>
                {showIniciais(item.usuariosCompartilhados[0])}
              </Avatar>
            </Badge>
            <span className="pasta-compartilhada-nome">
              {item.usuariosCompartilhados[0]}
            </span>
          </span>
        );
      }
    } else if (item.donoCompartilhamento) {
      return (
        <span className="lista-pasta-compartilhada-usuairos">
          <Badge size="small">
            <Avatar style={{ background: "#0042DD", color: "#FFFFFF" }}>
              {showIniciais(item.donoCompartilhamento)}
            </Avatar>
          </Badge>
          <span className="pasta-compartilhada-nome">
            {item.donoCompartilhamento}
          </span>
        </span>
      );
    }
  };

  const preImagemArquivo = (item) => {
    const extensao = item.extensao ?? item.nome.split(".")[1];

    let nomeArquivo =
      !item.nome.includes(".") && extensao != null
        ? `${item.nome}.${extensao}`
        : item.nome;

    if (item.urlPreview) {
      return (
        <img
          src={item.urlPreview}
          className={
            validarSePassouDaDataDeValidade(item.dataVencimento)
              ? "pasta-arquivo-pos-validade"
              : ""
          }
        />
      );
    } else {
      return (
        <div style={{ maxHeight: "1.5rem", maxWidth: "1.5rem" }}>
          <img
             src={getIconesExtensao(extensao)}
            className={
              
              validarSePassouDaDataDeValidade(item.dataVencimento)
                ? "pasta-arquivo-pos-validade"
                : ""
            }
          />
        </div>
      );
    }
  };

  return (
    <>
      <div className="row">
        <table className="table table-borderless col-lg-12">
          <tr>
            {tabelaColunas.length > 0 &&
              tabelaColunas.map((coluna, index) => (
                <th
                  onClick={() => {
                    coluna == "Nome" &&
                      setOrdenacao(
                        ordenacao == "tipo asc, nomeOrdenacao asc" ? "tipo desc, nomeOrdenacao desc" : "tipo asc, nomeOrdenacao asc"
                      );
                    coluna == "Classificação" &&
                      setOrdenacao(
                        ordenacao == "classificacao asc"
                          ? "classificacao desc"
                          : "classificacao asc"
                      );
                    coluna == "Dono" &&
                      setOrdenacao(
                        ordenacao == "donoCompartilhamento asc" ? "donoCompartilhamento desc" : "donoCompartilhamento asc"
                      );
                    coluna == "Tamanho" &&
                      setOrdenacao(
                        ordenacao == "tamanho asc"
                          ? "tamanho desc"
                          : "tamanho asc"
                      );
                    coluna == "Tipo" &&
                      setOrdenacao(
                        ordenacao == "tipo asc" ? "tipo desc" : "tipo asc"
                      );
                    coluna == "Acesso" &&
                      setOrdenacao(
                        ordenacao == "acesso asc"
                          ? "acesso desc"
                          : "acesso asc"
                      );
                    coluna == "Compartilhado em" &&
                      setOrdenacao(
                        ordenacao == "DataInclusao asc"
                          ? "DataInclusao desc"
                          : "DataInclusao asc"
                      );
                    coluna == "Data Compartilhamento" &&
                    setOrdenacao(
                      ordenacao == "DataInclusao asc"
                        ? "DataCompartilhamento desc"
                        : "DataCompartilhamento asc"
                    );
                  }}
                  style={{ cursor: "pointer" }}
                  key={index}
                >
                  {" "}
                  {coluna}
                  {coluna === "Nome" && ordenacao === "tipo desc, nomeOrdenacao desc" && (
                    <span>&#9650;</span>
                  )}
                  {coluna === "Nome" && ordenacao === "tipo asc, nomeOrdenacao asc" && (
                    <span>&#9660;</span>
                  )}
                  {coluna === "Classificação" &&
                    ordenacao === "classificacao desc" && <span>&#9650;</span>}
                  {coluna === "Classificação" &&
                    ordenacao === "classificacao asc" && <span>&#9660;</span>}
                  {coluna === "Dono" && ordenacao === "donoCompartilhamento desc" && (
                    <span>&#9650;</span>
                  )}
                  {coluna === "Dono" && ordenacao === "donoCompartilhamento asc" && (
                    <span>&#9660;</span>
                  )}
                  {coluna === "Tamanho" && ordenacao === "tamanho desc" && (
                    <span>&#9650;</span>
                  )}
                  {coluna === "Tamanho" && ordenacao === "tamanho asc" && (
                    <span>&#9660;</span>
                  )}
                  {coluna === "Tipo" && ordenacao === "tipo desc" && (
                    <span>&#9650;</span>
                  )}
                  {coluna === "Tipo" && ordenacao === "tipo asc" && (
                    <span>&#9660;</span>
                  )}
                  {coluna === "Acesso" &&
                    ordenacao === "acesso desc" && <span>&#9650;</span>}
                  {coluna === "Acesso" &&
                    ordenacao === "acesso asc" && <span>&#9660;</span>}
                  {coluna === "Data Compartilhamento" &&
                    ordenacao === "DataCompartilhamento desc" && (
                      <span>&#9650;</span>
                    )}
                  {coluna === "Data Compartilhamento" &&
                    ordenacao === "DataCompartilhamento asc" && (
                      <span>&#9650;</span>
                    )}
                </th>
              ))}
          </tr>
          <tbody>
            {(!data?.lista || data?.lista.length === 0) &&
              algumCompartilhamento && (
                <tr>
                  <td colSpan="7"> Sem Registros </td>
                </tr>
              )}
            {data?.lista &&
              data?.lista?.map((item, index) => (
                <RowDragInDrop
                  key={index}
                  data={item}
                  atualizarPastasDragInDrop={atualizarPastasDragInDrop}
                >
                  <td
                  >
                    {item.ehFavorito ? (
                      <svg
                        width="19"
                        height="16"
                        viewBox="0 0 19 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => {
                           handleRemoverFavorito(item);
                        }}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M9.13041 15.8983C9.2405 15.9652 9.36877 16.0005 9.49969 16C9.63094 16.0003 9.75945 15.9645 9.86959 15.8971C11.596 14.8398 13.2147 13.6332 14.7047 12.2929C17.4964 9.75541 18.9415 7.34873 19 5.1426V5.13969V5.00483C18.9999 3.95944 18.6533 2.94032 18.0088 2.09048C17.3643 1.24064 16.4542 0.602738 15.4063 0.266297C14.3584 -0.070143 13.2253 -0.0882356 12.166 0.214559C11.1066 0.517354 10.1743 1.12584 9.49969 1.95462C8.82499 1.126 7.89255 0.517697 6.83322 0.215079C5.77388 -0.087539 4.64081 -0.0692876 3.59301 0.267272C2.54522 0.603832 1.63528 1.24181 0.990889 2.09168C0.346496 2.94155 -6.44033e-06 3.96065 0 5.00599V5.13446V5.14376C0.0584691 7.34814 1.50357 9.75483 4.29532 12.2941C5.78529 13.6344 7.40395 14.841 9.13041 15.8983Z"
                          fill="#0042dd"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="19"
                        height="16"
                        viewBox="0 0 19 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={() => {favoritar(item);}}
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M9.13041 15.8983C9.2405 15.9652 9.36877 16.0005 9.49969 16C9.63094 16.0003 9.75945 15.9645 9.86959 15.8971C11.596 14.8398 13.2147 13.6332 14.7047 12.2929C17.4964 9.75541 18.9415 7.34873 19 5.1426V5.13969V5.00483C18.9999 3.95944 18.6533 2.94032 18.0088 2.09048C17.3643 1.24064 16.4542 0.602738 15.4063 0.266297C14.3584 -0.070143 13.2253 -0.0882356 12.166 0.214559C11.1066 0.517354 10.1743 1.12584 9.49969 1.95462C8.82499 1.126 7.89255 0.517697 6.83322 0.215079C5.77388 -0.087539 4.64081 -0.0692876 3.59301 0.267272C2.54522 0.603832 1.63528 1.24181 0.990889 2.09168C0.346496 2.94155 -6.44033e-06 3.96065 0 5.00599V5.13446V5.14376C0.0584691 7.34814 1.50357 9.75483 4.29532 12.2941C5.78529 13.6344 7.40395 14.841 9.13041 15.8983Z"
                          fill="#aaa"
                        />
                      </svg>
                    )}
                  </td>
                  <td
                    onClick={() =>
                      buscarPastasFilhas(
                        item.id,
                        item.tipo == 0 || item.tipo == 1 ? "pasta" : null,
                        item.nome
                      )
                    }
                  >
                    <span className="coluna-nome">
                      {item.tipo == 1 ? (
                        preImagemArquivo(item)
                      ) : (
                        <img
                          src={pastaSvg}
                          alt="pasta"
                          className={
                            validarSePassouDaDataDeValidade(item.dataVencimento)
                              ? "pasta-arquivo-pos-validade"
                              : ""
                          }
                        />
                      )}
                      <span>{item.nome}</span>
                    </span>
                  </td>
                  <td>{colunaCompartilhadoComDono(item)}</td>
                  <td
                    onClick={() =>
                      buscarPastasFilhas(
                        item.id,
                        item.tipo == 0 || item.tipo == 1 ? "pasta" : null,
                        item.nome
                      )
                    }
                  >
                    {" "}
                    {item.tamanho != 0 ? item.tamanho : " - "}{" "}
                  </td>
                  <td
                    onClick={() =>
                      buscarPastasFilhas(
                        item.id,
                        item.tipo == 0 || item.tipo == 1 ? "pasta" : null,
                        item.nome
                      )
                    }
                  >
                    {" "}
                    {item.tipo == 0 ? "Pasta" : item.extensao}{" "}
                  </td>
                  <td
                    onClick={() =>
                      buscarPastasFilhas(
                        item.id,
                        item.tipo == 0 || item.tipo == 1 ? "pasta" : null,
                        item.nome
                      )
                    }
                  >
                    {" "}
                    Total{" "}
                  </td>
                  <td
                   
                  >
                    {moment(item.dataCompartilhamento).format("DD/MM/YYYY HH:mm:ss")}
                  </td>
                  {item.tipo != null && (
                    <td className="text-right">
                      <List.Item className="list-item">
                        <Dropdown.Button
                          trigger={["click"]}
                          className="button-list"
                          overlay={() => showMenu(item.id, "pasta", item)}
                          placement="bottomLeft"
                          icon={<img src={IcTresPontos} alt="Ícone" />}
                        ></Dropdown.Button>
                      </List.Item>
                    </td>
                  )}
                </RowDragInDrop>
              ))}
          </tbody>
        </table>
      </div>
      <div>
        <TablePagination
          data={data}
          changePage={mudarPagina}
          isInputPagination={true}
        />
      </div>
    </>
  );
};

export default ListagemPastasCompartilhadas;
